/**
 * Default style for modal dialogs.
 * @type {Object}
 *
 * usage:
 * <Box
 * 	style={{
 * 		...modalStyle,
 * 		width: "95%",
 * 		height: "95%",
 * 		overflow: "auto",
 * 	}}
 * >
 * 	<></>
 * </Box>;
 */
export const modalStyle = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: 400,
	bgcolor: "background.paper",
	border: "2px solid #000",
	boxShadow: 24,
	pt: 2,
	px: 4,
	pb: 3,
	backgroundColor: "white",
};

/**
 * Metrea brand color palette and custom color references.
 * @type {Object}
 */
export const mColor = {
	// Metrea BLUE Book 1/27/2025
	Space: "#1d1a28",
	Sea: "#23466c",
	Air: "#618baa",
	Land: "#91a770",
	Simulations: "#fac734",
	Electromagnetic: "#e2695b",
	Cyber: "#9394b6",
	MidnightBlue: "#2c3c4c",
	NavyBlue: "#3e5265",
	SkyBlue: "#3b6c83",
	StonyBlue: "#7e9aa7",
	MistyBlue: "#d1e0e0",
	Primary1: "#2c3c4c", // MidnightBlue
	Primary2: "#3e5265", // NavyBlue
	Primary3: "#3b6c83", // SkyBlue
	Primary4: "#7e9aa7", // StonyBlue
	Primary5: "#d1e0e0", // MistyBlue

	Primary: "#3b6c83", // SkyBlue
	Marine: "#007DB6",
	Danger: "#d32f2f",
	Secondary: "#6c757d",
	CyanBlue: "#3d5265",
	White: "#ffffff",
};

/**
 * Returns true if the given hex color is "light" enough for dark text, otherwise false.
 * Uses the YIQ formula for brightness.
 * @param {string} hexcolor - Hex color string (e.g., "#FFFFFF").
 * @returns {boolean} True for "light" colors, false otherwise.
 */
export function getContrastYIQ(hexcolor) {
	hexcolor = hexcolor.replace(/#/g, "");
	var r = parseInt(hexcolor.substr(0, 2), 16);
	var g = parseInt(hexcolor.substr(2, 2), 16);
	var b = parseInt(hexcolor.substr(4, 2), 16);
	var yiq = (r * 299 + g * 587 + b * 114) / 1000;
	return yiq >= 160 ? true : false;
}

const ACTIVE_BG = "blue.700";
const ACTIVE_BORDER = "blue.700";
const ACTIVE_TITLE = "blue.800";
const INACTIVE_BORDER = "gray.300";
const INACTIVE_TITLE = "gray.700";
const INACTIVE_CIRCLE_TEXT = "gray.600";
const SEPARATOR_BG = "gray.300";

export const getIndicatorStyle = (index, activeStep) => {
	const isActive = index === activeStep;
	return {
		bg: "transparent",
		border: "none",
		p: 0,
		m: 0,
		__circle: {
			w: 8,
			h: 8,
			rounded: "full",
			borderWidth: "2px",
			display: "inline-flex",
			alignItems: "center",
			justifyContent: "center",
			fontSize: "sm",
			bg: isActive ? ACTIVE_BG : "transparent",
			borderColor: isActive ? ACTIVE_BORDER : INACTIVE_BORDER,
			color: isActive ? "white" : INACTIVE_CIRCLE_TEXT,
		},
	};
};

export const getTitleStyle = (index, activeStep) => {
	const isActive = index === activeStep;
	return {
		color: isActive ? ACTIVE_TITLE : INACTIVE_TITLE,
		fontWeight: isActive ? "semibold" : "normal",
	};
};

export const getSeparatorStyle = () => ({
	bg: SEPARATOR_BG,
	h: "2px",
});
